<template>
  <div>
    <CRow class="mb-3 search-panel">
      <CCol xs="12" sm="1" class="form-group" style="min-width: 105px; max-width: 120px;">
        <label>Thao tác</label>
        <div class="dropdown btn-group" style="height: 36px;">
          <button class="btn">
            <div class="group-checkbox">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  v-model="actionData.model.selectedAll"
                  @change="changeSelectAll"
                  id="selectedAll"
                />
                <label class="custom-control-label" for="selectedAll"></label>
              </div>
            </div>
          </button>
          <button
            type="button"
            class="dropdown-toggle dropdown-toggle-split btn"
            data-toggle="dropdown"
            aria-expanded="false"
            aria-haspopup="true"
          ></button>
          <div class="dropdown-menu">
            <button
              :disabled="actionData.model.listCategorySelectedId.length === 0"
              class="dropdown-item"
              @click="setupSelectOneAction('delete_list')"
              color="danger"
            >
              <CIcon name="cil-trash" style="danger" class="mr-2"/>
              Xóa tất cả
            </button>
          </div>
        </div>
      </CCol>
      <CCol sm="3" md="3" xl="2" xs="12">
        <BaseInput
          :options="nameInput.options"
          :data="nameInput.data"
          :listener="nameInput.listener"
        />
      </CCol>
      <CCol sm="3" md="3" xl="2" xs="12">
        <BaseSelect :options="statusSelect.options" :data="statusSelect.data"
                    ref="statusSelect"></BaseSelect>
      </CCol>
      <CCol>
        <div class="form-group">
          <label style="color: white"></label>
          <div style="margin-top: 10px">
            <CButton
              style="float: right;margin-left: 5px;"
              color="primary"
              v-c-tooltip.hover="'Tải lại'"
              class="btn-action-primary"
              @click="loadDataMainTable(true)">
              <i class="fa fa-refresh"></i>&nbsp;&nbsp; Tải lại
            </CButton>
            <CButton
              style="float: right;"
              color="primary"
              v-c-tooltip.hover="'Thêm mới'"
              class="btn-action-primary"
              @click="clickAdd()"
            >
              <i class="fa fa-plus"></i>&nbsp;&nbsp; Thêm mới
            </CButton>
          </div>
        </div>
      </CCol>
    </CRow>
    <CCard class="content-fade-in mt-3p5">
      <CCardBody>
        <BaseTable
          :options="mainTable.options"
          :slots="mainTable.slots"
          :dataSource="mainTable.dataSource"
          ref="mainTable"
        >
          <template #checkbox="{item}">
            <td class="group-checkbox">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  v-model="actionData.model.listCategorySelectedId"
                  :value="item.id"
                  :id="item.id"
                  v-c-tooltip.hover="'Selected'"
                />
                <label class="custom-control-label" :for="item.id"></label>
              </div>
            </td>
          </template>

          <template #createDate="{item}">
            <td>
              {{ $helper.formatDateDDMMYYYYHHMM(item.createDate) }}
            </td>
          </template>
          <template #name="{item}">
            <td>
              <span style="font-weight: 550;">{{ item.name }}</span>
            </td>
          </template>
          <template #status="{item}">
            <td>
                <span v-if="item.status == 1" class="dot-custom dot-success">
                Hoạt động
              <BaseSwitch class="mx-1" color="success" checked variant="3d" v-c-tooltip.hover="'Vô hiệu hóa'"
                          v-bind="labelIcon"
                          @update:checked="setupSelectOneAction('update_status', item.id, item.name, item.status)"
              />
              </span>
              <span v-else class="dot-custom dot-danger">
                Vô hiệu hóa
                <BaseSwitch class="mx-1" color="danger" variant="3d" v-c-tooltip.hover="'Hoạt động'"
                            v-bind="labelIcon"
                            @update:checked="setupSelectOneAction('update_status', item.id, item.name, item.status)"/>
              </span>
            </td>
          </template>

          <template #action="{item}">
            <td class="action-btn-group">
              <div class="action-btn-wrapper">
                <CButton
                  color="info"
                  variant="outline"
                  v-c-tooltip.hover="'Cập nhật'"
                  square
                  size="sm"
                  @click="loadCategoryById(item.id)"
                >
                  <CIcon name="cil-pencil"/>
                </CButton>
                <CButton
                  color="danger"
                  variant="outline"
                  class="ml-1"
                  square
                  size="sm"
                  v-c-tooltip.hover="'Xóa'"
                  @click="setupSelectOneAction('delete_one', item.id, item.name)">
                  <CIcon name="cil-trash"/>
                </CButton>
              </div>
            </td>
          </template>
        </BaseTable>
      </CCardBody>
    </CCard>
    <CModal :title="dataSave.idField.data.model ? 'Cập nhật chức vụ' : 'Thêm mới chức vụ'" :show.sync="isShowModal"
            :closeOnBackdrop="false">
      <CRow class="pb-2">
        <CCol sm="12" md="12" xl="12" xs="12">
          <BaseInput
            :options="dataSave.nameInput.options"
            :data="dataSave.nameInput.data"
            :listener="dataSave.nameInput.listener"
          />
        </CCol>
        <CCol sm="12" md="12" xl="12" xs="12">
          <BaseSelect :options="dataSave.statusSelect.options" :data="dataSave.statusSelect.data"
                      ref="saveStatusSelect"></BaseSelect>
        </CCol>
      </CRow>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="isShowModal = false"><i class="fa fa-times"></i> Hủy bỏ
        </button>
        <button type="button" class="btn btn-primary" @click="submitData()"><i class="fa"
                                                                               :class="dataSave.idField.data.model ? 'fa-check' : 'fa-plus'"></i>
          {{ dataSave.idField.data.model ? 'Cập nhật' : 'Thêm mới' }}
        </button>
      </template>
    </CModal>
    <ModalConfirm :actionTypeMapping="actionData.actionTypeMapping"
                  ref="actionModal"></ModalConfirm>
  </div>
</template>

<script>
import BaseTable from "../base/BaseDataTable";
import ModalConfirm from "../base/BaseModalConfirm";
import BaseInput from "../base/BaseInput";
import BaseSwitch from "@/views/base/BaseSwitch";
import BaseSelect from "@/views/base/BaseSelect2";

export default {
  name: "UsersList",
  components: {
    BaseSwitch,
    BaseTable,
    ModalConfirm,
    BaseInput,
    BaseSelect
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Error"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data() {
    let that = this;
    let actionTypeMapping = new Map();

    actionTypeMapping.set("delete_one", {
      url: "/category-user/delete",
      titlePopup: function () {
        return that.$helper.setupTitleAction(
          "xóa",
          "chức vụ",
          that.actionData.model.categorySelectedName
        );
      },
      isJsonContentType: false,
      dataSubmit: function () {
        return {id: that.actionData.model.categorySelectedId};
      },
      successCallback: function () {
        that.actionData.model.listUserSelectedId = [];
        that.showSuccessMsg({message: "Xóa chức vụ " + that.actionData.model.categorySelectedName + " thành công"});
        that.loadDataMainTable();
      }
    });

    actionTypeMapping.set("delete_list", {
      url: "/category-user/delete-ids",
      titlePopup: function () {
        return that.$helper.setupTitleAction("xóa", "các chức vụ", "đã chọn");
      },
      isJsonContentType: false,
      dataSubmit: function () {
        return {
          lsId: that.actionData.model.listCategorySelectedId
        };
      },
      successCallback: function () {
        that.actionData.model.listCategorySelectedId = [];
        that.showSuccessMsg({message: "Xóa danh sách chức vụ thành công"});
        that.loadDataMainTable();
      },
    });

    actionTypeMapping.set("update_status", {
      url: "/category-user/update-status",
      titlePopup: function () {
        return that.$helper.setupTitleAction(that.actionData.model.categoryStatus == true ? "vô hiệu hóa" : "hoạt động", "chức vụ", that.actionData.model.categorySelectedName);
      },
      isJsonContentType: false,
      dataSubmit: function () {
        return {
          id: that.actionData.model.categorySelectedId
        };
      },
      successCallback: function () {
        that.showSuccessMsg({message: that.actionData.model.categoryStatus == true ? "Vô hiệu hóa chức vụ thành công" : "Hoạt động chức vụ thành công"});
        that.loadDataMainTable();
      },
    });

    return {
      isShowModal: false,
      labelIcon: {
        labelOn: '\u2713',
        labelOff: '\u2715'
      },
      actionData: {
        actionTypeMapping: actionTypeMapping,
        model: {
          selectedAll: false,
          categorySelectedId: null,
          categorySelectedName: null,
          categoryStatus: null,
          listCategorySelectedId: []
        }
      },
      nameInput: {
        options: {
          placeholder: "Tên chức vụ",
          label: 'Tên chức vụ'
        },
        data: {
          name: "name",
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          }
        }
      },
      statusSelect: {
        options: {
          filter: false,
          label: 'Trạng thái',

        },
        data: {
          name: "status",
          items: [
            {key: "null", value: "Tất cả trạng thái"},
            {key: "1", value: "Hoạt động"},
            {key: "0", value: "Không hoạt động"},
          ],
          model: "null",
          updateTrigger: function () {
            return that.$refs.mainTable;
          }
        }
      },
      mainTable: {
        options: {
          fields: [
            {key: "checkbox", label: "#"},
            {key: "createDate", label: "Ngày tạo"},
            {key: "name", label: "Tên chức vụ"},
            {key: "status", label: "Trạng thái"},
            {key: "action", label: "Thao tác"}
          ],
          slots: ["checkbox", "name", "status", "createDate", "action"],
        },
        dataSource: {
          url: "/category-user/page-category",
          dataSubmit: function () {
            return that.$helper.setupDataSubmit(that.$data);
          },
          response: function (dataResponse) {
            return dataResponse.data;
          }
        }
      },
      dataSave: {
        idField: {
          data: {
            name: "id",
            model: ""
          }
        },
        /* name */
        nameInput: {
          options: {
            label: "Tên chức vụ <span class='required'>*</span>",
            placeholder: "Tên chức vụ",
          },
          data: {
            name: "name",
            model: "",
            updateCallback: function () {
              that.submitData();
            },
            validator: {
              isValid: true,
              errorMessage: "",
              valid: function () {
                let value = that.dataSave.nameInput.data.model;
                if (value === "") {
                  this.isValid = false;
                  this.errorMessage = "Tên chức vụ không được để trống";
                } else if (value.length > 128) {
                  this.isValid = false;
                  this.errorMessage = "Tên chức vụ được quá 128 kí tự";
                } else {
                  this.isValid = true;
                }
                return this.isValid;
              }
            }
          }
        },
        statusSelect: {
          options: {
            filter: false,
            label: 'Trạng thái',
          },
          data: {
            name: "status",
            items: [
              {key: "1", value: "Hoạt động"},
              {key: "0", value: "Không hoạt động"},
            ],
            model: "1",
          }
        }
      }
    }
  },
  methods: {
    loadDataMainTable: function (isUpdateFilter) {
      this.$refs.mainTable.loadData(true, isUpdateFilter);
    },
    changeSelectAll: function (event) {
      if (this.actionData.model.selectedAll) {
        this.actionData.model.listCategorySelectedId = [];
        this.$refs.mainTable.items.forEach(each => {
          this.actionData.model.listCategorySelectedId.push(each.id);
        });
      } else {
        this.actionData.model.listCategorySelectedId = [];
      }
    },
    setupSelectOneAction: function (actionTypeKey, categorySelectedId, categorySelectedName, categoryStatus) {
      let actionData = this.actionData.model;
      actionData.categorySelectedId = categorySelectedId || null;
      actionData.categorySelectedName = categorySelectedName || null;
      actionData.categoryStatus = categoryStatus || null;
      this.$refs.actionModal.setCurrAction(actionTypeKey);
    },
    clickAdd() {
      this.isShowModal = true;
      this.dataSave.idField.data.model = "";
      this.dataSave.nameInput.data.model = "";
      this.dataSave.statusSelect.data.model = "1";
    },
    loadCategoryById(id) {
      let that = this;
      that.isShowModal = true;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/category-user/find-by-id",
        isJsonContentType: false,
        dataSubmit: function () {
          return {id: id}
        },
        successCallback: function (response) {
          that.isShowModal = true;
          that.$helper.setupDataResponse(that.$data.dataSave, response.data.data);
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    submitData() {
      let that = this;
      let urlSubmit = "/category-user/create";
      if (this.dataSave.idField.data.model) {
        urlSubmit = "/category-user/update";
      }
      this.$helper.loadDataSource({
        loading: that.loading,
        url: urlSubmit,
        dataRef: function () {
          return that.$data.dataSave;
        },
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
            that.$helper.setupErrorModel(response.data.data, that.$data.dataSave);
          } else {
            that.showSuccessMsg({message: that.dataSave.idField.data.model ? "Cập nhật chức vụ thành công" : "Thêm mới chức vụ thành công"});
            that.isShowModal = false
            that.loadDataMainTable()
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    }
  },
  created: function () {
  },
  mounted() {
  },
  watch: {
    "actionData.model.listCategorySelectedId": function (newValue) {
      let that = this;
      if (newValue.length === that.$refs.mainTable.items.length) {
        that.actionData.model.selectedAll = true;
      } else {
        that.actionData.model.selectedAll = false;
      }
    }
  },
  computed: {}
};
</script>
<style scoped>
.td-roles {
  max-width: 250px;
}
</style>
